import roleManage from '@/views/setting/views/roleManage/roleManage';
export default roleManage;